import type { Look } from '../../shared/cosmetics.ts';
import { useAuth } from './auth.ts';
import { usePreferences } from './preferences.ts';

export interface DisplayIdentity {
  name: string;
  /** Avatar, frame and name style; null for guests. */
  look: Look | null;
  /** Rating of a signed-in player; null for guests. */
  rating: number | null;
  signedIn: boolean;
}

/** Who the player appears as: their account when signed in, otherwise their guest nickname. */
export function useDisplayName(): DisplayIdentity {
  const { user } = useAuth();
  const { prefs, t } = usePreferences();
  if (user?.username) return { name: user.username, look: user.look, rating: user.rating, signedIn: true };
  return { name: prefs.playerName.trim() || t('friend.namePlaceholder'), look: null, rating: null, signedIn: false };
}
